export default __webpack_public_path__ + "static/media/concept.e3c1bd87.jpg";